"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInteractableHeight = useInteractableHeight;
var _useScale = require("../scale/useScale");
var _interactableHeight = require("../tokens/interactableHeight");
function useInteractableHeight(compact) {
  const scale = (0, _useScale.useScale)();
  const variant = compact ? 'compact' : 'regular';
  return _interactableHeight.interactableHeight[scale][variant];
}